import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  settingsEventSwitch,
  settingsDiscordSwitch,
  settingsSwitch,
} from "../redux/actions/settings.action";
import { useTranslation } from "react-i18next";
import patrolImg from "assets/img/patrol.png";
import oilImg from "assets/img/oilrig.png";
import cargoImg from "assets/img/cargo.png";
import vendingImg from "assets/img/vendingmachine.png";
import deepseaImg from "assets/img/deepsea.png";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CustomInput,
  Table,
  FormGroup,
  Input,
  UncontrolledTooltip,
  Modal,
  ModalBody,
} from "reactstrap";

const gameEvents = [
  {
    key: "deepSeaOpened",
    img: deepseaImg,
  },
  {
    key: "deepSeaClosed",
    img: deepseaImg,
  },
  {
    key: "heliEnter",
    img: patrolImg,
  },
  {
    key: "heliDowned",
    img: patrolImg,
  },
  {
    key: "smallRigUnlocked",
    img: oilImg,
  },
  {
    key: "smallRigScientists",
    img: oilImg,
  },
  {
    key: "largeRigUnlocked",
    img: oilImg,
  },
  {
    key: "largeRigScientists",
    img: oilImg,
  },
  {
    key: "cargoLeft",
    img: cargoImg,
  },
  {
    key: "cargoEnter",
    img: cargoImg,
  },
  {
    key: "newVending",
    img: vendingImg,
  },
];
const Settings = (props) => {
  const { t } = useTranslation(["settings", "common"]);
  useEffect(() => {
    document.querySelector("body").scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setIngamePrefix(props.ingame.prefix);
  }, [props.ingame.prefix]);

  const getEventImg = (name) => {
    var img = false;
    img = gameEvents.filter((e) => e.key === name);
    if (img && img.length) {
      return img[0].img;
    } else return false;
  };
  const [ingamePrefix, setIngamePrefix] = useState(props.ingame.prefix);
  const changeIngamePrefix = (e) => {
    const value = e.target.value;
    if (value.length < 2) {
      setIngamePrefix(value);
    }
  };
  const editIngamePrefix = () => {
    if (ingamePrefix !== props.ingame.prefix)
      props.settingsSwitch("ingame.prefix", ingamePrefix);
  };

  /*const [ingamePrefixSamOff, setIngamePrefixSamOff] = useState(props.ingame.samOff);
  const changeIngamePrefixSamOff = (e) => {
    const value = e.target.value;
    if (value.length < 2) {
      setIngamePrefixSamOff(value);
    }
  }
  const changeIngamePrefixeditIngamePrefixSamOff = () => {
    if (ingamePrefixSamOff !== props.ingame.samOff) props.settingsSwitch('ingame.samOff', ingamePrefixSamOff);
  }

  const [ingamePrefixSamOn, setIngamePrefixSamOn] = useState(props.ingame.samOn);
  const changeIngamePrefixSamOn = (e) => {
    const value = e.target.value;
    if (value.length < 2) {
      setIngamePrefixSamOn(value);
    }
  }
  
  const editIngamePrefixSamOn = () => {
    if (ingamePrefixSamOn !== props.ingame.samOn) props.settingsSwitch('ingame.samOn', ingamePrefixSamOn);
  }*/

  const userPlan = props.vip.plan;
  const [modalDisplay, setModalDisplay] = useState(false);
  const ignoredEvents = [
    "bradleyDowned",
    "bradleyRespawn",
    "bradleyCrates",
    "smallRigLooted",
    "smallRigRespawned",
    "smallRigRefresh",
    "largeRigLooted",
    "largeRigRespawned",
    "largeRigRefresh",
    "cargoFirstCrate",
    "cargoSecondCrate",
    "cargoLastCrate",
    "chinookCrate",
  ];
  const settingsDistanceSwitch = (arg, key, checked, fromModal = false) => {
    if (fromModal) {
      localStorage.setItem("checkDistance", "true");
      props.settingsEventSwitch(arg, key, checked);
      return setModalDisplay(false);
    }
    if (!localStorage.getItem("checkDistance")) {
      setModalDisplay({
        arg,
        key,
        checked,
      });
      return false;
    } else {
      props.settingsEventSwitch(arg, key, checked);
    }
  };
  return (
    <>
      <Modal
        className="distanceModal"
        isOpen={modalDisplay}
        animation={false}
        fade={false}
      >
        <div className="modal-header justify-content-center">
          <button
            aria-hidden={true}
            className="close modalClose"
            data-dismiss="modal"
            type="button"
          >
            <i
              className="tim-icons icon-simple-remove"
              onClick={() => setModalDisplay(false)}
            />
          </button>
        </div>
        <ModalBody className="modalBody">
          <p className="text-white">{t("modalDistance")}</p>
        </ModalBody>
        <div className="modal-footer">
          <Button
            color="default"
            type="button"
            onClick={() =>
              settingsDistanceSwitch(
                modalDisplay.arg,
                modalDisplay.key,
                modalDisplay.checked,
                true,
              )
            }
          >
            {t("common:confirm")}
          </Button>
          <Button
            color="default"
            type="button"
            onClick={() => setModalDisplay(false)}
          >
            {t("common:cancel")}
          </Button>
        </div>
      </Modal>
      <div className="content">
        <motion.div
          initial={{ opacity: 0.5, x: -100 }}
          animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}
        >
          <Card className="settings-events">
            <CardHeader>
              <CardTitle tag="h4">{t("settingsEvents")}</CardTitle>
            </CardHeader>
            <CardBody>
              <Table responsive className="overflowHidden">
                <thead className="text-primary">
                  <tr key="titles">
                    <th></th>
                    <th>{t("event")}</th>
                    <th className="text-right switchPadding">
                      {t("distance")}
                    </th>
                    <th className="text-right switchPadding">{t("ingame")}</th>
                    <th className="text-right switchPadding">Discord</th>
                  </tr>
                </thead>
                <tbody className="tBodySettings">
                  {userPlan < 2 && (
                    <div className="settingsBlurred">
                      <div className="settingsBlurredCentered">
                        <div className="featureNotAllowed c-white">
                          {t("featureNotIncluded")}
                        </div>
                        <Button className="upgradeBtn" tag={Link} to="/plans">
                          {t("upgrade")}
                        </Button>
                      </div>
                    </div>
                  )}
                  {props.events &&
                    props.events.length &&
                    props.events.map((event) => {
                      if (ignoredEvents.includes(event.key)) return <></>;
                      return (
                        <tr key={event.key}>
                          <td className="text-center">
                            <div className="photo">
                              <img
                                alt="event-icon"
                                src={getEventImg(event.key)}
                              />
                            </div>
                          </td>
                          <td>{t(`${event.key}`)}</td>
                          <td
                            className="text-right"
                            id={`settings-${event.key}-distance`}
                          >
                            <CustomInput
                              type="switch"
                              id={`switch-${event.key}-distance`}
                              className="mt-n4"
                              checked={event.distance}
                              onChange={(e) =>
                                settingsDistanceSwitch(
                                  "distance",
                                  event.key,
                                  e.target.checked,
                                )
                              }
                            />
                          </td>
                          <td
                            className="text-right"
                            id={`settings-${event.key}-ingame`}
                          >
                            <CustomInput
                              type="switch"
                              id={`switch-${event.key}-ingame`}
                              checked={event.ingame}
                              onChange={(e) =>
                                props.settingsEventSwitch(
                                  "ingame",
                                  event.key,
                                  e.target.checked,
                                )
                              }
                              className="mt-n4"
                            />
                          </td>
                          <td
                            className="text-right"
                            id={`settings-${event.key}-discord`}
                          >
                            <CustomInput
                              type="switch"
                              id={`switch-${event.key}-discord`}
                              className="mt-n4"
                              checked={event.discord}
                              onChange={(e) =>
                                props.settingsEventSwitch(
                                  "discord",
                                  event.key,
                                  e.target.checked,
                                )
                              }
                            />
                          </td>
                          {userPlan < 3 && (
                            <UncontrolledTooltip
                              placement="left"
                              target={`settings-${event.key}-distance`}
                            >
                              {t("common:featureNotAvailable")}
                            </UncontrolledTooltip>
                          )}
                          {userPlan < 2 && (
                            <UncontrolledTooltip
                              placement="left"
                              target={`settings-${event.key}-ingame`}
                            >
                              {t("common:featureNotAvailable")}
                            </UncontrolledTooltip>
                          )}
                          {userPlan < 2 && (
                            <UncontrolledTooltip
                              placement="left"
                              target={`settings-${event.key}-discord`}
                            >
                              {t("common:featureNotAvailable")}
                            </UncontrolledTooltip>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </motion.div>
        <Card className="settings-channels">
          <CardHeader>
            <CardTitle tag="h4">{t("globalSettings")}</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive className="overflowHidden">
              <tbody>
                <tr key="twelveDates">
                  <td>{t(`twelveDates`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-twelveDates`}
                      className="mt-n4"
                      checked={props.twelveDates}
                      onChange={(e) =>
                        props.settingsSwitch("twelveDates", e.target.checked)
                      }
                    />
                  </td>
                </tr>
                <tr key="rawAlarms">
                  <td>{t(`rawAlarms`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-rawAlarms`}
                      className="mt-n4"
                      checked={props.rawAlarms}
                      onChange={(e) =>
                        props.settingsSwitch("rawAlarms", e.target.checked)
                      }
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
        <Card className="settings-channels">
          <CardHeader>
            <CardTitle tag="h4">{t("discordSettings")}</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive className="overflowHidden">
              <tbody>
                {props.channel &&
                  Object.keys(props.channel).length &&
                  Object.keys(props.channel).map((key) => {
                    return (
                      <tr key={key}>
                        <td>{t(`${key}`)}</td>
                        <td className="text-right">
                          <CustomInput
                            type="switch"
                            id={`switch-${key}`}
                            className="mt-n4"
                            checked={props.channel[key]}
                            onChange={(e) =>
                              props.settingsDiscordSwitch(key, e.target.checked)
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
                <tr key="wideAlarms">
                  <td>{t(`wideAlarms`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-wideAlarms`}
                      className="mt-n4"
                      checked={props.wideAlarms}
                      onChange={(e) =>
                        props.settingsSwitch("wideAlarms", e.target.checked)
                      }
                    />
                  </td>
                </tr>
                <tr key="notifyDeaths">
                  <td>{t(`notifyDeaths`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-notifyDeaths`}
                      className="mt-n4"
                      checked={props.notifyDeaths}
                      onChange={(e) =>
                        props.settingsSwitch("notifyDeaths", e.target.checked)
                      }
                    />
                  </td>
                </tr>
                <tr key="sendDeaths">
                  <td>{t(`sendDeaths`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-sendDeaths`}
                      className="mt-n4"
                      checked={userPlan >= 3 && props.sendDeaths}
                      onChange={(e) =>
                        props.settingsSwitch(
                          "discord.sendDeaths",
                          e.target.checked,
                        )
                      }
                    />
                  </td>
                  {userPlan < 3 && (
                    <UncontrolledTooltip
                      placement="left"
                      target={`switch-sendDeaths`}
                    >
                      {t("common:featureNotAvailable")}
                    </UncontrolledTooltip>
                  )}
                </tr>
                <tr key="sendStatus">
                  <td>{t(`sendStatus`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-sendStatus`}
                      className="mt-n4"
                      checked={userPlan >= 3 && props.sendStatus}
                      onChange={(e) =>
                        props.settingsSwitch(
                          "discord.sendStatus",
                          e.target.checked,
                        )
                      }
                    />
                  </td>
                  {userPlan < 3 && (
                    <UncontrolledTooltip
                      placement="left"
                      target={`switch-sendDeaths`}
                    >
                      {t("common:featureNotAvailable")}
                    </UncontrolledTooltip>
                  )}
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
        <Card className="settings-channels">
          <CardHeader>
            <CardTitle tag="h4">{t("ingameSettings")}</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive className="overflowHidden">
              <tbody>
                <tr key="ingameTrackStatus">
                  <td>{t(`trackStatus`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-trackStatus`}
                      className="mt-n4"
                      checked={props.ingame.trackStatus}
                      onChange={(e) =>
                        props.settingsSwitch(
                          "ingame.trackStatus",
                          e.target.checked,
                        )
                      }
                    />
                  </td>
                </tr>
                <tr key="ingameChatEnable">
                  <td>{t(`chatEnabled`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-chatEnabled`}
                      className="mt-n4"
                      checked={props.ingame.enabled}
                      onChange={(e) =>
                        props.settingsSwitch("ingame.enabled", e.target.checked)
                      }
                    />
                  </td>
                </tr>
                <tr key="keepLeader">
                  <td>{t(`keepLeader`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-keepLeader`}
                      className="mt-n4"
                      checked={props.ingame.keepLeader}
                      onChange={(e) =>
                        props.settingsSwitch(
                          "ingame.keepLeader",
                          e.target.checked,
                        )
                      }
                    />
                  </td>
                </tr>
                <tr key="trackDeaths">
                  <td>{t(`trackDeaths`)}</td>
                  <td className="text-right">
                    <CustomInput
                      type="switch"
                      id={`switch-trackDeaths`}
                      className="mt-n4"
                      checked={userPlan >= 3 && props.ingame.trackDeaths}
                      onChange={(e) =>
                        props.settingsSwitch(
                          "ingame.trackDeaths",
                          e.target.checked,
                        )
                      }
                    />
                  </td>
                  {userPlan < 3 && (
                    <UncontrolledTooltip
                      placement="left"
                      target={`switch-trackDeaths`}
                    >
                      {t("common:featureNotAvailable")}
                    </UncontrolledTooltip>
                  )}
                </tr>
                <tr key="ingamePrefix">
                  <td>{t(`ingamePrefix`)}</td>
                  <td className="text-right">
                    <FormGroup className="settings-prefix">
                      <Input
                        className="text-center inputPrefix"
                        placeholder="!"
                        value={ingamePrefix}
                        onChange={changeIngamePrefix}
                        onBlur={editIngamePrefix}
                        type="text"
                      />
                    </FormGroup>
                  </td>
                </tr>
                {/*<tr key="ingamePrefixSamOff">
                    <td>{t(`ingamePrefixSamOff`)}</td>
                    <td className="text-right">
                      <FormGroup className="settings-prefix">
                        <Input className="text-center inputPrefix" placeholder="-" value={ingamePrefixSamOff} onChange={changeIngamePrefixSamOff} onBlur={editIngamePrefixSamOff} type="text" />
                      </FormGroup>
                    </td>
                </tr>*/}
                {/*<tr key="ingamePrefixSamOn">
                    <td>{t(`ingamePrefixSamOn`)}</td>
                    <td className="text-right">
                      <FormGroup className="settings-prefix">
                        <Input className="text-center inputPrefix" placeholder="*" value={ingamePrefixSamOn} onChange={changeIngamePrefixSamOn} onBlur={editIngamePrefixSamOn} type="text" />
                      </FormGroup>
                    </td>
                </tr>*/}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { events, twelveDates, ingame, notifyDeaths, wideAlarms, rawAlarms } =
    state.settings;
  const { channel, sendDeaths, sendStatus } = state.settings.discord;
  const { vip } = state.infos;
  return {
    events,
    channel,
    twelveDates,
    vip,
    ingame,
    notifyDeaths,
    wideAlarms,
    sendDeaths,
    sendStatus,
    rawAlarms,
  };
};

const mapDispatchToProps = {
  settingsEventSwitch,
  settingsDiscordSwitch,
  settingsSwitch,
};

//export default Settings;
export default connect(mapStateToProps, mapDispatchToProps)(Settings);
